<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <template v-if="isAdmin">
          <el-button type="primary" :size="$store.state.buttonSize" @click="orgPopup()"
            >新增企业</el-button
          >
          <RemoveButton
            type="info"
            @click="handleRemoveAll"
            :disabled="!selectionID.length"
            >批量删除</RemoveButton
          >
        </template>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="orgName" label="企业名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.orgName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="adminAreaName" label="管理区域">
        <template slot-scope="scope">
          {{ scope.row.provinceName + '/' + scope.row.cityName + '/' + scope.row.countyName + '/' + scope.row.townName }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="详细地址"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" :width="isAdmin ? 230 : 100">
        <template slot-scope="scope">
          <el-button type="text" @click="orgintroductionPopup(scope.row.id)"
            >企业简介</el-button
          >
          <template v-if="isAdmin">
            <el-button type="text" @click="authPopup(scope.row.id)"
              >企业权限</el-button
            >
            <el-button type="text" @click="orgPopup(scope.row.id)"
              >编辑</el-button
            >
            <el-button type="text" @click="orgDel(scope.row.id)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawer" size="40%" :with-header="false">
      <div
        v-if="detailDate.infoResponse"
        class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>政府企业详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">企业名称</td>
            <td>{{ detailDate.orgName }}</td>
            <td class="list-item">企业简称</td>
            <td>{{ detailDate.shortName }}</td>
          </tr>
          <tr>
            <td class="list-item">管理员</td>
            <td>{{ detailDate.adminName }}</td>
            <td class="list-item">法人</td>
            <td>{{ detailDate.infoResponse.legalPerson }}</td>
          </tr>
          <tr>
            <td class="list-item">注册资金</td>
            <td>{{ detailDate.infoResponse.registeredFund }}</td>
            <td class="list-item">注册时间</td>
            <td>{{ detailDate.infoResponse.registerDate | formatDate }}</td>
          </tr>
          <tr>
            <td class="list-item">经度</td>
            <td>{{ detailDate.infoResponse.longitude }}</td>
            <td class="list-item">纬度</td>
            <td>{{ detailDate.infoResponse.latitude }}</td>
          </tr>
          <tr>
            <td class="list-item">邮箱</td>
            <td>{{ detailDate.email }}</td>
            <td class="list-item">联系电话</td>
            <td>{{ detailDate.orgPhone }}</td>
          </tr>
          <tr>
            <td class="list-item">传真</td>
            <td>{{ detailDate.fax }}</td>
            <td class="list-item">生产地址</td>
            <td>
              <p v-for="(item, index) in detailDate.list" :key="item.id">
                {{ index }}.{{ item.productionAddress }}
              </p>
            </td>
          </tr>
          <tr>
            <td class="list-item">管理区域</td>
            <td>{{ detailDate.provinceName + '/' + detailDate.cityName + '/' + detailDate.countyName + '/' + detailDate.townName }}</td>
            <td class="list-item">详细地址</td>
            <td>{{ detailDate.address }}</td>
          </tr>
          <tr>
            <td class="list-item">创建时间</td>
            <td>{{ detailDate.createTime | format }}</td>
            <td class="list-item"></td>
            <td></td>
          </tr>
        </table>
      </div>
    </el-drawer>
    <!-- 企业权限 -->
    <el-dialog title="企业权限" width="50%" :visible.sync="orgAuthVisible" center :close-on-click-modal="false">
      <el-tree
        :data="authTree"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="refAuthTree"
        highlight-current
        :check-strictly="true"
        :props="defaultProps">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" @click="debounceAuthSubmit">保存</el-button>
        <el-button @click="resetChecked" :size="$store.state.buttonSize">取消</el-button>
      </div>
    </el-dialog>
    <!-- 用户管理 -->
    <el-dialog title="企业用户" width="70%" :visible.sync="userTableVisible" center :close-on-click-modal="false">
      <UserManagement />
    </el-dialog>
    <!-- 角色管理 -->
    <el-dialog
     :close-on-click-modal="false"
      title="角色管理"
      width="70%"
      :visible.sync="roleManagementVisible"
      center
    >
      <RoleManagement />
    </el-dialog>
    <!-- 层级管理 -->
    <el-dialog
      :close-on-click-modal="false"
      title="层级管理"
      width="70%"
      :visible.sync="tierManagementVisible"
      center
    >
      <TierManagement />
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="企业简介"
      width="60%"
      :visible.sync="orgintroductionVisible"
      center
    >
      <el-form
        :model="orgintroductionForm"
        :size="$store.state.formSize"
        label-width="0px"
      >
        <el-form-item label="">
          <vue-ueditor-wrap v-model="orgintroductionForm.content" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceOrgintroduction"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetOrgintroductionFormVals">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新建/编辑企业 -->
    <el-dialog :title="title" width="70%" :visible.sync="orgFormVisible" :close-on-click-modal="false" center>
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first"> -->
          <el-form
            :model="orgForm"
            :size="$store.state.formSize"
            :rules="orgFormRules"
            ref="refOrgForm"
            label-width="140px"
            style="padding-right: 30px;"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="企业名称：" prop="orgName">
                  <el-input v-model="orgForm.orgName" @input="setShortName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="简称：" prop="shortName">
                  <el-input v-model="orgForm.shortName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="所属区域：" prop="addressList">
                  <el-cascader
                    :props="props"
                    :placeholder="orgForm.addressStr"
                    v-model="orgForm.addressStr"
                    @change="townSelect($event)"
                    @expand-change="citySelect($event)"
                    style="width:100%;"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：">
                  <el-input v-model="orgForm.address" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="法人：" prop="legalPerson">
                  <el-input v-model="orgForm.legalPerson" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系人：">
                  <el-input v-model="orgForm.contacts" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="管理员名称：" prop="adminName">
                  <el-input v-model="orgForm.adminName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="注册时间：" prop="registerDate">
                  <el-date-picker
                    v-model="orgForm.registerDate"
                    value-format="yyyy-MM-dd"
                    autocomplete="off"
                    type="date"
                    style="width:100%"
                    :placeholder="orgForm.registerDate"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  v-for="(item, index) in orgForm.productionAddress"
                  :key="item.key"
                  label="生产地址：">
                  <el-input v-model="item.value" autocomplete="off"></el-input>
                  <i v-if="index === 0" class="product-select-icon el-icon-plus" @click="onAddDynamicForm"></i>
                  <i v-else class="product-select-icon  el-icon-close" @click="onDelDynamicForm(index)"></i>
                </el-form-item>
                <el-form-item label="经度：">
                  <el-input :disabled="mapDisabled" v-model="orgForm.longitude" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="纬度：">
                  <el-input :disabled="mapDisabled" v-model="orgForm.latitude" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册资金(万元)：" prop="registeredFund">
                  <el-input v-model="orgForm.registeredFund" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：">
                  <el-input v-model="orgForm.email" autocomplete="off" placeholder="邮箱格式：XXX@XXX.XXX"></el-input>
                </el-form-item>
                <el-form-item label="电话：">
                  <el-input v-model="orgForm.orgPhone" autocomplete="off" placeholder="电话格式：XXXX-XXXXXXXX"></el-input>
                </el-form-item>
                <el-form-item label="传真：">
                  <el-input v-model="orgForm.fax" autocomplete="off" placeholder="传真格式：XXXX-XXXXXXXX"></el-input>
                </el-form-item>
                <el-form-item label="位置标注：">
                </el-form-item>
                  <baidu-map v-bind:style="mapStyle" class="bm-view" ak="你的百度地图ak" :center="center" :zoom="zoom" :scroll-wheel-zoom="true" @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
                    <bm-view style="width: 100%; height:500px;"></bm-view>
                    <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
                    <bm-control :offset="{width: '10px', height: '10px'}">
                      <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 999999}">
                          <input type="text" placeholder="请输入搜索关键字" class="serachinput">
                      </bm-auto-complete>
                    </bm-control>
                    <bm-local-search :keyword="keyword" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
                  </baidu-map>
              </el-col>
            </el-row>
          </el-form>
        <!-- </el-tab-pane>
        <el-tab-pane label="资质信息" name="second">资质信息</el-tab-pane>
      </el-tabs> -->
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker } from 'vue-baidu-map'
import VueUeditorWrap from 'vue-ueditor-wrap'
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import UserManagement from './components/UserManagement'
import RoleManagement from './components/RoleManagement'
import TierManagement from './components/TierManagement'
import {
  putOrgAdd,
  postOrgEdit,
  getOrgList,
  getOrgDetail,
  deleteOrgDel,
  delOrgList,
  putOrgintroductionAdd,
  getOrgintroductionDetail,
  postOrgintroductionEdit
} from '@/api/companies'
import {
  getGovResource,
  putGovResourceAdd
} from '@/api/government'
import { getIsAdmin } from '@/api/routers'
import { getCity } from '@/api/city'
import {
  getResourceTree
} from '@/api/resource'
const createForm = () => ({
  addressList: null,
  addressStr: '',
  // 机构地址
  address: '',
  // *管理员名称
  adminName: '',
  // *省
  province: null,
  // *市
  city: null,
  // *乡
  town: null,
  // *县
  county: null,
  // 联系人
  contacts: '',
  email: '',
  fax: '',
  // 纬度
  latitude: null,
  // 经度
  longitude: null,
  // *法人
  legalPerson: '',
  // *机构名称
  orgName: '',
  // 电话
  orgPhone: '',
  // 生产地址
  productionAddress: [
    { key: '1', value: '' }
  ],
  // *注册时间
  registerDate: '',
  // *注册资金(万元)
  registeredFund: null,
  // 企业简称
  shortName: ''
})
const createOrgintroductionForm = () => ({
  content: '',
  orgId: null,
  id: undefined
})

export default {
  components: {
    UserManagement,
    RoleManagement,
    TierManagement,
    BaiduMap,
    BmControl,
    BmView,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker,
    VueUeditorWrap
  },
  data() {
    return {
      isAdmin: false,
      activeName: 'first',
      orgintroductionId: null,
      authTree: [],
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 层级设置，解决在弹出窗口中下拉菜单被遮罩问题
        zIndex: 10000,
        // 上传文件接口（WFS）
        serverUrl: `${process.env.VUE_APP_BASE_API}/trace/wfs/ueditor`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      },
      orgFormVisible: false,
      userTableVisible: false,
      orgAuthVisible: false,
      roleManagementVisible: false,
      tierManagementVisible: false,
      defaultProps: {
        children: 'children',
        label: 'resourceName'
      },
      currentID: null,
      drawer: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      tableData: [],
      detailDate: {},
      orgintroductionVisible: false,
      orgintroductionForm: createOrgintroductionForm,
      orgForm: createForm,
      orgFormRules: {
        adminName: [
          { required: true, message: '请填写管理员名称', trigger: 'blur' }
        ],
        orgName: [
          { required: true, message: '请填写企业名称', trigger: 'blur' }
        ],
        shortName: [
          { required: true, message: '请填写企业简称', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请填写法人', trigger: 'blur' }
        ],
        registerDate: [
          { required: true, message: '请选择注册时间', trigger: 'blur' }
        ],
        registeredFund: [
          { required: true, message: '请填写注册资金', trigger: 'blur' }
        ],
        addressList: [
          { required: true, message: '请选择所属区域', trigger: 'blur' }
        ]
      },
      props: {
        // 获取管理区域城市tree
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node
          let valueArr = []
          if (value) {
            valueArr = value.split(',')
          }
          getCity({
            code: valueArr[0] || '100000000'
          }).then(res => {
            const nodes = Array.from(res.data).map(item => ({
              label: item.name,
              value: item.code + ',' + item.id,
              code: item.code,
              // 判断最后一层
              leaf: item.type > 3
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          })
        }
      },
      loading: true,
      isDisabled: false,
      mapDisabled: true,
      selectionID: [],
      orgId: null,
      uid: 1,
      // 百度地图参数
      showMapComponent: this.value,
      keyword: '',
      mapStyle: {
        width: '100%',
        height: this.mapHeight + 'px'
      },
      center: { lng: 116.404, lat: 39.915 },
      zoom: 15
    }
  },
  watch: {
    value: function (currentValue) {
      this.showMapComponent = currentValue
      if (currentValue) {
        this.keyword = ''
      }
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑企业' : '新增企业'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.orgSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceAuthSubmit = debounce(300, this.authSubmit)
    this.debounceOrgintroduction = debounce(300, this.orgintroductionSubmit)
    getIsAdmin().then(res => {
      this.isAdmin = res.data
    })
  },
  methods: {
    // 地图
    getClickInfo(e) {
      this.orgForm.latitude = e.point.lat
      this.orgForm.longitude = e.point.lng
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    },
    syncCenterAndZoom(e) {
      const { lng, lat } = e.target.getCenter()
      this.center.lng = lng
      this.center.lat = lat
      this.zoom = e.target.getZoom()
    },
    onDelDynamicForm(index) {
      this.orgForm.productionAddress.splice(index, 1)
    },
    onAddDynamicForm() {
      this.orgForm.productionAddress.push({
        key: ++this.uid,
        value: ''
      })
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delOrgList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getOrgListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.orgFormVisible = false
      this.$set(this, 'orgForm', createForm())
      this.$refs.refOrgForm.clearValidate()
    },
    hanleResetOrgintroductionFormVals() {
      this.orgintroductionVisible = false
      this.$set(this, 'orgintroductionForm', createOrgintroductionForm())
    },
    // 简称
    setShortName() {
      this.orgForm.shortName = this.orgForm.orgName
    },
    // 区域选择
    citySelect(event) {
      if (event.length > 2) {
        this.orgForm.province = parseInt(event[0].split(',')[1])
        this.orgForm.city = parseInt(event[1].split(',')[1])
        this.orgForm.county = parseInt(event[2].split(',')[1])
      }
    },
    townSelect(event) {
      this.orgForm.town = parseInt(event.split(',')[1])
      this.orgForm.addressList = 'ok'
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getOrgListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getOrgListData()
    },
    // 新增/编辑企业简介
    orgintroductionSubmit() {
      // this.orgintroductionForm.id = this.orgintroductionId || undefined
      const orgintroductionChange = this.orgintroductionForm.id === undefined ? putOrgintroductionAdd : postOrgintroductionEdit
      console.log(this.orgintroductionForm)
      orgintroductionChange(this.orgintroductionForm).then(res => {
        if (res.status === 1) {
          this.orgintroductionVisible = false
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 打开企业简介
    orgintroductionPopup(id) {
      this.orgintroductionVisible = true
      this.$set(this, 'orgintroductionForm', createOrgintroductionForm())
      this.orgintroductionForm.orgId = id
      getOrgintroductionDetail(id).then(res => {
        if (res.status === 1) {
          if (res.data) {
            this.orgintroductionForm.content = res.data.content
            this.orgintroductionForm.id = res.data.id
            this.orgintroductionForm.orgId = id
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 提交权限配置
    authSubmit() {
      const authIds = this.$refs.refAuthTree.getCheckedKeys()
      putGovResourceAdd({
        orgId: this.orgId,
        resourceIds: authIds
      }).then(res => {
        if (res.status === 1) {
          this.orgAuthVisible = false
          this.$message.success('权限配置成功')
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 打开权限配置
    authPopup(id) {
      this.$nextTick(() => {
        console.log(this.$refs)
      })
      // 获取权限
      getGovResource(id).then(res => {
        console.log(res)
        const result = res.map(_ => _.resourceId)
        console.log(result)
        this.$refs.refAuthTree.setCheckedKeys(result)
      })

      this.orgId = id
      this.orgAuthVisible = true
    },
    // 关闭权限选择
    resetChecked() {
      this.orgAuthVisible = false
      this.$refs.refAuthTree.setCheckedKeys([])
    },
    // 删除企业
    orgDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteOrgDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除企业成功')
              this.getOrgListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/修改排班
    orgSubmit() {
      this.$refs.refOrgForm.validate(valid => {
        if (!valid) return false
        const changeOrg = this.currentID ? postOrgEdit : putOrgAdd
        changeOrg({
          address: this.orgForm.address,
          contacts: this.orgForm.contacts,
          email: this.orgForm.email,
          fax: this.orgForm.fax,
          adminName: this.orgForm.adminName,
          orgName: this.orgForm.orgName,
          orgPhone: this.orgForm.orgPhone,
          shortName: this.orgForm.shortName,
          province: this.orgForm.province,
          city: this.orgForm.city,
          town: this.orgForm.town,
          county: this.orgForm.county,
          latitude: parseFloat(this.orgForm.latitude),
          longitude: parseFloat(this.orgForm.longitude),
          legalPerson: this.orgForm.legalPerson,
          productionAddress: this.orgForm.productionAddress.map(_ => _.value),
          registerDate: this.orgForm.registerDate,
          registeredFund: parseFloat(this.orgForm.registeredFund),
          id: this.currentID || undefined
        }).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('修改企业成功')
              : this.$message.success('新增企业成功')
            this.orgFormVisible = false
            this.getOrgListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开新增/修改表单
    orgPopup(id) {
      this.$set(this, 'orgForm', createForm())
      const isAdd = !id
      this.orgFormVisible = true

      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getOrgDetail(id).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.center.lng = res.data.infoResponse.longitude
            this.center.lat = res.data.infoResponse.latitude
            this.orgForm.address = res.data.address
            this.orgForm.adminName = res.data.adminName
            this.orgForm.orgName = res.data.orgName
            this.orgForm.shortName = res.data.shortName
            this.orgForm.contacts = res.data.contacts
            this.orgForm.email = res.data.email
            this.orgForm.fax = res.data.fax
            this.orgForm.orgPhone = res.data.orgPhone
            this.orgForm.longitude = res.data.infoResponse.longitude
            this.orgForm.latitude = res.data.infoResponse.latitude
            this.orgForm.registeredFund = res.data.infoResponse.registeredFund
            this.orgForm.legalPerson = res.data.infoResponse.legalPerson
            this.orgForm.registerDate = moment(res.data.infoResponse.infoResponse).format('YYYY-MM-DD')
            this.orgForm.productionAddress = []
            this.orgForm.province = res.data.province
            this.orgForm.city = res.data.city
            this.orgForm.county = res.data.county
            this.orgForm.town = res.data.town
            this.orgForm.addressList = 'ok'
            this.orgForm.addressStr = res.data.provinceName + '/' + res.data.cityName + '/' + res.data.countyName + '/' + res.data.townName
            res.data.list.forEach((_, i) => {
              this.onAddDynamicForm()
              this.orgForm.productionAddress[i].value = _.productionAddress
            })
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getOrgListData()
    },
    // 刷新数据表格
    refresh() {
      this.getOrgListData()
      this.$message.success('数据刷新成功')
    },
    // 企业详情
    detailShow(id) {
      this.drawer = true
      getOrgDetail(id).then(res => {
        console.log(res.data)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 请求数据列表
    getOrgListData() {
      this.loading = true
      getOrgList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    // 获取资源权限列表
    getResourceTreeData() {
      getResourceTree().then(res => {
        if (res.status === 1) {
          this.authTree = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getOrgListData()
    this.getResourceTreeData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
